import {AxiosPromise} from "axios"
import RequestHelper, {ActionAnswer} from "../utils/RequestsHelper"

export default class CliApi {
    /**
     * @deprecated The method should not be used since 1.4.21
     */
    public static runStock(): AxiosPromise<ActionAnswer<{task_id: number}>> {
        return RequestHelper.send("get", "cli&action=startSyncStock")
    }

    public static runDownloadExportedProducts(): AxiosPromise<ActionAnswer<{task_id: number}>> {
        return RequestHelper.send("get", "cli&action=downloadExportedProducts")
    }

    public static runSyncPrice(): AxiosPromise<ActionAnswer<{task_id: number}>> {
        return RequestHelper.send("get", "cli&action=syncPrice")
    }
    public static runSyncOrders(): AxiosPromise<ActionAnswer> {
        return RequestHelper.send("get", "cli&action=syncOrders")
    }

    public static runDownloadDictionary(attribute_id: number, category_id: number): AxiosPromise<ActionAnswer> {
        return RequestHelper.send("get", "cli&action=downloadDictionary", {attribute_id, category_id})
    }
}